import { createContext, useContext, useState, useEffect } from "react";
import { translations } from "@/i18n/translations";

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("app-lang") || "de");

  useEffect(() => {
    localStorage.setItem("app-lang", lang);
  }, [lang]);

  const t = (key) => translations[lang]?.[key] || translations.de[key] || key;

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) throw new Error("useLanguage must be used within LanguageProvider");
  return context;
}
